import { Box } from "grommet";
import React, { lazy, Suspense } from "react";
import { Switch, withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import LoadingPage from "../../components/LoadingPage";
import MenuBarLayout from "../../components/MenuBarLayout";
import ProtectedRoute from "../../components/ProtectedRoute";
import { getPermissionCode } from "../../utils/pagePermission";

const CourtHome = lazy(() => import("../CourtHome"));
const DeviceConfig = lazy(() => import("../DeviceConfig"));
const DeviceStatus = lazy(() => import("../DeviceStatus"));
const GMBConfiguration = lazy(() => import("../GMBConfiguration"));
const ErrorReport = lazy(() => import("../ErrorReport"));
const RouteManagement = lazy(() => import("../RouteManagement"));
const TripReplay = lazy(() => import("../TripReplay"));
const TripViewer = lazy(() => import("../TripViewer"));
const ArrivalTimetable = lazy(() => import("../ArrivalTimetable"));
const OfflineReport = lazy(() => import("../OfflineReport"));
const MilesReport = lazy(() => import("../MilesReport"));
const OutOfRouteReport = lazy(() => import("../OutOfRouteReport"));
const DailyOperationReport = lazy(() => import("../DailyOperationReport"));
const TempDisableETA = lazy(() => import("../TempDisableETA"));
const TempDisableETAIndividual = lazy(() => import("../TempDisableETAIndividual"));
const VehicleAllocationReport = lazy(() =>
  import("../VehicleAllocationReport")
);
const OperatorConfig = lazy(() => import("../OperatorConfig"));
const FFNDReport = lazy(() => import("../FFNDReport"));
const RSLReport = lazy(() => import("../RSLReport"));
const JourneyTimeReport = lazy(() => import("../NewJourneyTimeReport"));
const JourneyTimeExceptionReport = lazy(() =>
  import("../JourneyTimeExceptionReport")
);
const OperationSummaryReport = lazy(() => import("../OperationSummaryReport"));
const UserConfig = lazy(() => import("../UserConfig"));
const AddRoute = lazy(() => import("../AddRoute"));
const LddInstallation = lazy(() => import("../LddInstallation"));
const ScheduleConfig = lazy(() => import("../ScheduleConfig"));
const ExceptionSummaryReport = lazy(() => import("../ExceptionSummaryReport"));
const DepartureArrivalReport = lazy(() => import("../DepartureArrivalReport"));
const SpeedingReport = lazy(() => import("../SpeedingReport"));
const OORDayReport = lazy(() => import("../OORDayReport"));
const OORHourReport = lazy(() => import("../OORHourReport"));
const GeoFencing = lazy(() => import("../GeoFencing"));
const S3Archive = lazy(() => import("../S3Archive"));

const CourtRoot = (props) => {
  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",

      // backgroundColor: '#F2F2F2'
    },
    content: {
      flexGrow: 1,
      // padding: theme.spacing(3),
      // margin: '64px 0 24px 0'
    },
  }));

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <main className={classes.content}>
        <MenuBarLayout>
          <Box style={{ width: "100%", height: "100%" }}>
            {/* <ProtectedRoute path="/" exact component={Root} /> */}
            <Suspense fallback={<LoadingPage />}>
              <Switch>
                <ProtectedRoute
                  pagePermission={getPermissionCode("court-home")}
                  path="/"
                  exact
                  component={CourtHome}
                />
                {/* ============ Styled ============ */}
                <ProtectedRoute
                  pagePermission={getPermissionCode("trip-viewer")}
                  path="/trips"
                  component={TripViewer}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("trip-replay")}
                  path="/trip-replay"
                  exact
                  component={TripReplay}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("trip-replay")}
                  path="/trip-replay/:tripId"
                  component={TripReplay}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("geo-fencing")}
                  path="/geo-fencing/:pslId?"
                  component={GeoFencing}
                />
                {/* ============ Unstyled ============ */}
                <ProtectedRoute
                  pagePermission={getPermissionCode("route-management")}
                  path="/route-management/:pslId?/:routeId?/:routeSeq?/:version?"
                  component={RouteManagement}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("add-route")}
                  path="/add-route"
                  component={AddRoute}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("error-report")}
                  path="/error-report"
                  component={ErrorReport}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("gmb-config")}
                  path="/gmb-config"
                  component={GMBConfiguration}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("device-config")}
                  path="/device-config"
                  component={DeviceConfig}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("device-status")}
                  path="/device-status"
                  component={DeviceStatus}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("schedule-config")}
                  path="/schedule-config"
                  component={ScheduleConfig}
                />
                {/* {TD GMB } */}
                <ProtectedRoute
                  pagePermission={getPermissionCode("arrival-timetable")}
                  path="/arrival-timetable"
                  component={ArrivalTimetable}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("offline-report")}
                  path="/offline-report"
                  component={OfflineReport}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("miles-report")}
                  path="/miles-report"
                  component={MilesReport}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("out-of-route-report")}
                  path="/out-of-route-report"
                  component={OutOfRouteReport}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("daily-operation-report")}
                  path="/daily-operation-report"
                  component={DailyOperationReport}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode(
                    "vehicle-allocation-report"
                  )}
                  path="/vehicle-allocation-report"
                  component={VehicleAllocationReport}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("operator-config")}
                  path="/operator-config"
                  component={OperatorConfig}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("user-config")}
                  path="/user-config"
                  component={UserConfig}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("ffnd-report")}
                  path="/ffnd-report"
                  component={FFNDReport}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("rsl-report")}
                  path="/rsl-report"
                  component={RSLReport}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("journey-time-report")}
                  path="/journey-time-report"
                  component={JourneyTimeReport}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode(
                    "journey-time-exception-report"
                  )}
                  path="/journey-time-exception-report"
                  component={JourneyTimeExceptionReport}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("operation-summary-report")}
                  path="/operation-summary-report"
                  component={OperationSummaryReport}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("ldd-installation")}
                  path="/ldd-installation"
                  component={LddInstallation}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("exception-summary-report")}
                  path="/exception-summary-report"
                  component={ExceptionSummaryReport}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("speeding-report")}
                  path="/speeding-report"
                  component={SpeedingReport}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("departure-arrival-report")}
                  path="/departure-arrival-report"
                  component={DepartureArrivalReport}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("oor-day-report")}
                  path="/oor-day-report"
                  component={OORDayReport}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("oor-hour-report")}
                  path="/oor-hour-report"
                  component={OORHourReport}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("temp-disable-eta")}
                  path="/temp-disable-eta"
                  component={TempDisableETA}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("temp-disable-eta-individual")}
                  path="/temp-disable-eta-individual"
                  component={TempDisableETAIndividual}
                />
                <ProtectedRoute
                  pagePermission={getPermissionCode("s3-archive")}
                  path="/s3-archive"
                  component={S3Archive}
                />
              </Switch>
            </Suspense>
          </Box>
        </MenuBarLayout>
      </main>
    </div>
  );
};

export default withRouter(CourtRoot);
